import { Controller } from "@hotwired/stimulus"
import { GridStack } from "gridstack"

// Wraps GridStack over a dashboard's own .grid-stack container (see
// organizations/dashboards/show.html.erb) -- the one drag/resize dependency in this app. Each
// .grid-stack-item's gs-x/gs-y/gs-w/gs-h attributes seed GridStack from DashboardWidget's own
// persisted grid_x/y/w/h columns; every drag or resize fires GridStack's own "change" event with
// the widgets that actually moved, which gets bulk-saved back to DashboardsController#reposition
// in one request rather than one per widget.
//
// editableValue is false for a viewer (see DashboardPolicy#update?) -- GridStack's own staticGrid
// option renders the identical grid with every drag/resize handle disabled, so a viewer sees
// exactly the same layout an admin does, just not able to change it.
export default class extends Controller {
  static values = { editable: Boolean, repositionUrl: String }

  connect() {
    this.grid = GridStack.init({
      staticGrid: !this.editableValue,
      column: 12,
      cellHeight: "80px",
      float: true
    }, this.element.querySelector(".grid-stack"))

    if (this.editableValue) {
      this.grid.on("change", () => this.savePositions())
    }
  }

  disconnect() {
    this.grid?.destroy(false)
  }

  savePositions() {
    clearTimeout(this.saveTimer)
    this.saveTimer = setTimeout(() => this.persist(), 400)
  }

  async persist() {
    const widgets = [ ...this.element.querySelectorAll(".grid-stack-item") ].map((item) => ({
      id: item.dataset.widgetId,
      grid_x: item.getAttribute("gs-x"),
      grid_y: item.getAttribute("gs-y"),
      grid_w: item.getAttribute("gs-w"),
      grid_h: item.getAttribute("gs-h")
    }))

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch(this.repositionUrlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
        body: JSON.stringify({ widgets })
      })
    } catch {
      // A dropped save leaves the layout as GridStack already has it on screen -- the next drag
      // or resize (or a plain reload) tries again; not worth interrupting someone mid-arrangement
      // over a network blip.
    }
  }
}
